import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5ed72436&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Header.vue?vue&type=style&index=1&id=5ed72436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed72436",
  null
  
)

export default component.exports